// GENERATED FROM 'messages.json' (via yarn run messages:generate)
// !! DO NOT CHANGE MANUALLY !!

import { defineMessages } from "react-intl";

export const messages = defineMessages({
    gameLensPreviewError: {
        id: "apps.lensPreview.validation.gameLensPreviewError",
        description: "Game lens preview error.",
        defaultMessage: "To publish, upload a 5–10s gameplay video to help speed up review.",
    },
    gameLensVideoTooShortError: {
        id: "apps.lensPreview.validation.gameLensVideoTooShortError",
        description: "Game lens video too short error.",
        defaultMessage: "Video is too short. Please upload a 5–10s gameplay clip.",
    },
    gameLensVideoDurationOutOfRangeError: {
        id: "apps.lensPreview.validation.gameLensVideoDurationOutOfRangeError",
        description: "Game lens video duration out of range error.",
        defaultMessage: "Video must be between 5 and 10 seconds for Game Lenses",
    },
});
